import React from 'react';
import {
  Modal, ModalBody, Spinner,
} from 'reactstrap';
import PropTypes from 'prop-types';
import ModalFileContent from './ModalFileContent';


class ModalFileViewer extends React.Component {
  constructor() {
    super();
    this.state = {
      isLoadedFileContent: false,
    };
  }

  setLoadedFileContent(value) {
    this.setState(prevState => ({
      ...prevState,
      isLoadedFileContent: value,
    }));
  }

  render() {
    const {
      isModal, toggle, fileInfo, saveFile, isLoadedFile,
    } = this.props;
    const { isLoadedFileContent } = this.state;
    return (
      <Modal
        isOpen={isModal}
        toggle={toggle}
        modalClassName="ltr-support"
        className="modal-image-viewer"
        fade={false}
      >
        <div className="header-file">
          <h2 className="text-white">{fileInfo.name}</h2>
          <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
        </div>
        {/* <div className="modal__header">
          <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
          <h4 className="semiBold text-modal modal__title">
            {fileInfo.name || 'Chargement...'}
          </h4>
        </div> */}
        <ModalBody className="p-0">
          {
            isLoadedFile ? (
              <ModalFileContent fileInfo={fileInfo} saveFile={saveFile} isLoadedFileContent={isLoadedFileContent} setLoadedFileContent={v => this.setLoadedFileContent(v)} />
            ) : (
              <div className="loaderContainer">
                <Spinner color="primary" role="status" aria-hidden="true" />
              </div>
            )
          }
        </ModalBody>
      </Modal>
    );
  }
}


ModalFileViewer.propTypes = {
  isModal: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  fileInfo: PropTypes.shape({}).isRequired,
  isLoadedFile: PropTypes.bool.isRequired,
  saveFile: PropTypes.func.isRequired,
};

export default ModalFileViewer;
